// external scripts
import $ from "jquery";
import debug from "bows";

// flexible layouts
// import Accordion from './layouts/_accordion';

// example of ES2015 modules loading & tree shaking
import {
	emptyLinks,
	externalLinks
} from "./_links";

import breakpoints from "./_breakpoints";

const $window = $(window);
const $document = $(document);
const $body = $("body");
// const log       = debug('site');

class Pasgobeyond {
	constructor() {
		this.breakpoints = breakpoints;

		$document.ready(() => this.domReady());
	}

	domReady() {
		const log = debug("site:domReady");

		this.gTranslate();

		log("dom.ready");
	}

	gTranslate() {
		if ($('#gtranslate_wrapper').length != 1) return;

		$('#gtranslate_wrapper').appendTo('.pgb-navbar__menu-translate');

		if ($('.pgb-navbar__menu-translate #gtranslate_wrapper .switcher .selected a').text().toLowerCase().replace(' ', '') === 'english') {
			$('.pgb-navbar__menu-translate #gtranslate_wrapper .option a[title="English"]').hide();
			$('.pgb-navbar__menu-translate #gtranslate_wrapper .option a[title="Español"]').show();
		} else {
			$('.pgb-navbar__menu-translate #gtranslate_wrapper .option a[title="English"]').show();
			$('.pgb-navbar__menu-translate #gtranslate_wrapper .option a[title="Español"]').hide();
		}

		$('.pgb-navbar__menu-translate #gtranslate_wrapper .option a').on('click', (e) => {
			$('.pgb-navbar__menu-translate #gtranslate_wrapper .option a').show();
			$(e.target).hide();
		});

		$('.pgb-navbar__menu-translate #gtranslate_wrapper').attr('style', 'display: block !important;');
	}
}

export default Pasgobeyond;
